import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import ReportsGemstoneService from "../../../services/reports-Gemstone.service";
import ReportScaffold from "./_shared/ReportScaffold";
import { COLOR_CONFIG } from "./_shared/reportConfigs";
import { exportChartPdf } from "./_shared/exportChartPdf";

const GemstoneReportsColorIndComp = () => {
  const loginDetials = useSelector((state) => state.loginReducer);

  const initialGlobalGemstoneState = {
    dataRangeFrom: moment().subtract(30, "days").format("YYYY-MM-DD"),
    dataRangeTo: moment().format("YYYY-MM-DD"),
    SelectedGemstoneValue: "All",
    retailerIds: [],
    vendorIds: [],
  };

  const [globalGemstones, setGlobalGemstone] = useState(initialGlobalGemstoneState);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);
  const [dealerId, setDealerId] = useState();
  const [forDealer, setForDealer] = useState("");
  const [refetchToken, setRefetchToken] = useState(0);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [chartFilterValue, setChartFilterValue] = useState("");

  useEffect(() => {
    if (loginDetials?.loginDetials?.responseData?.logInSucceeded) {
      setDealerId(loginDetials.loginDetials.responseData.dealerId);
      handleCheckDealermembers(loginDetials.loginDetials.responseData.dealerId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCheckDealermembers = (id) => {
    ReportsGemstoneService.CheckDealermembers({ dealerID: id })
      .then((response) => {
        if (response.data.message === "Success") {
          let fd;
          if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "VendorGemstone" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Vendor"
          ) {
            fd = 1;
          } else if (
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Retailer" ||
            loginDetials.loginDetials.responseData.dealerMemberTypeName === "Combined"
          ) {
            fd = 2;
          } else {
            fd = 3;
          }
          setForDealer(fd || "");
          handleLoadReport(id, fd);
        } else {
          setForDealer("");
        }
      })
      .catch(() => setForDealer(""));
  };

  const handleLoadReport = (dealerIdArg, forDealerArg) => {
    let inputData = {
      dealerID: dealerIdArg.toString(),
      forDealer: forDealerArg ? forDealerArg.toString() : "",
      fromDate: globalGemstones.dataRangeFrom
        ? moment(globalGemstones.dataRangeFrom).format("YYYY-MM-DD")
        : "2020-08-17",
      toDate: globalGemstones.dataRangeTo
        ? moment(globalGemstones.dataRangeTo).format("YYYY-MM-DD")
        : "2022-09-15",
      retailerIds: globalGemstones.retailerIds.toString(),
      vendorIds: globalGemstones.vendorIds.toString(),
      selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
      reportName: "ExtendedGemstoneCharts",
    };

    setLoading(true);
    ReportsGemstoneService.LoadExtendedGemstoneChartReports(inputData)
      .then((response) => {
        setLoading(false);
        if (response.data.message === "Success" && response.data.responseData) {
          setReport(response.data.responseData);
        } else {
          setReport(null);
        }
      })
      .catch(() => {
        setLoading(false);
        setReport(null);
      });
  };

  const onDateChange = (dates, dateStrings) => {
    if (dates) {
      setGlobalGemstone((prevState) => ({
        ...prevState,
        dataRangeFrom: dateStrings[0],
        dataRangeTo: dateStrings[1],
      }));
    }
  };

  const onGemstoneTypeChange = (e, name) => {
    setGlobalGemstone({ ...globalGemstones, [name]: e });
  };

  const handleApplyFilter = () => {
    handleLoadReport(dealerId, forDealer);
    setRefetchToken((tok) => tok + 1);
  };

  // Clicking a chart slice/bar filters the detail table to that value;
  // clicking the same slice again (or the clear badge) toggles it back off.
  const handleChartSliceClick = (label) => {
    setChartFilterValue((prev) => (prev === label ? "" : label));
  };

  const handleDownloadChart = async () => {
    setPdfLoading(true);
    try {
      await exportChartPdf({
        elementId: "pdf-content",
        title: COLOR_CONFIG.pageTitle,
        dealerCompany: loginDetials?.loginDetials?.responseData?.dealerCompany,
        dealerId,
        dataRangeFrom: globalGemstones.dataRangeFrom,
        dataRangeTo: globalGemstones.dataRangeTo,
        selectedGemstoneValue: globalGemstones.SelectedGemstoneValue,
        totalClicks: report?.TotalGemstoneClicks?.[0]?.TotalClickCnt,
        fileName: "Gemstone-Color-Search-Report.pdf",
      });
    } finally {
      setPdfLoading(false);
    }
  };

  return (
    <ReportScaffold
      config={COLOR_CONFIG}
      report={report}
      loading={loading}
      dealerId={dealerId}
      forDealer={forDealer}
      dealerCompany={loginDetials?.loginDetials?.responseData?.dealerCompany}
      globalGemstones={globalGemstones}
      onDateChange={onDateChange}
      onGemstoneTypeChange={onGemstoneTypeChange}
      onApplyFilter={handleApplyFilter}
      refetchToken={refetchToken}
      onDownloadChart={handleDownloadChart}
      downloadingChart={pdfLoading}
      onChartClick={handleChartSliceClick}
      chartFilterValue={chartFilterValue}
    />
  );
};

export default GemstoneReportsColorIndComp;
